import { FC } from "react";
import { BomPageExplainerCloseButton, BomPageExplainerTrigger } from "../atoms";
import { BomPageExplainerFooter, BomPageExplainerHeader } from "../molecules";
import * as Dialog from "../ui/dialog";
import { BomPageExplainerContent } from "../organisms";

interface BomPageExplainerDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  className?: string;
}
export const BomPageExplainerDialog: FC<BomPageExplainerDialogProps> = ({
  open,
  setOpen,
}) => {
  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Trigger asChild id="explainer-dialog-trigger">
        <BomPageExplainerTrigger />
      </Dialog.Trigger>
      <Dialog.Content>
        <Dialog.Header className="flex items-center gap-2.5 bg-mandarin-50">
          <BomPageExplainerHeader />
        </Dialog.Header>
        <BomPageExplainerContent />
        <Dialog.Footer>
          <BomPageExplainerFooter />
        </Dialog.Footer>
        <Dialog.Close asChild className="absolute bottom-5 right-5">
          <BomPageExplainerCloseButton />
        </Dialog.Close>
      </Dialog.Content>
    </Dialog.Root>
  );
};
